const initialState = {
    scribeRemainingTime: 0,
    paidASRCreditTime: 0,
};
export default function scribeFirebase(state = initialState, action) {
    switch (action.type) {
        case 'FIREBASE_USER_LOGIN_SUCCESS':
            return Object.assign(Object.assign({}, state), { user: action.user, isNew: action.isNew });
        case 'FIREBASE_USER_LOGOUT':
            return Object.assign(Object.assign({}, state), { user: undefined });
        case 'FETCH_AVA_SESSION_SUCCESS':
            if (!action.photoUrl)
                return Object.assign({}, state);
            return Object.assign(Object.assign({}, state), { user: Object.assign(Object.assign({}, state.user), { photoURL: action.photoUrl }), isNew: false });
        case 'UPDATE_SCRIBE_REMAINING_TIME':
            return Object.assign(Object.assign({}, state), { scribeRemainingTime: action.scribeRemainingTimeMs });
        case 'UPDATE_PAID_ASR_CREDIT_TIME':
            return Object.assign(Object.assign({}, state), { paidASRCreditTime: action.paidASRCreditTime });
        case 'DECREASE_PAID_ASR_CREDIT_TIME':
            return Object.assign(Object.assign({}, state), { paidASRCreditTime: state.paidASRCreditTime - 1000 });
        case 'DECREASE_SCRIBE_REMAINING_TIME':
            return Object.assign(Object.assign({}, state), { scribeRemainingTime: state.scribeRemainingTime - 1000 });
        default:
            // eslint-disable-next-line no-unused-expressions
            action;
            return state;
    }
}
